"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/**
 * @react-component Alert - outputs alert based on criticality and rendering requirements.
 *
 * @param { string } alertType - criticality options: critical, warning, help, success
 * @param { string | object } message - main content to display in alert; string in the case of a normal text
 * string and an object with the property `__html` when `isInnerHtml` is set to `true`
 * @param { boolean } isInnerHtml - if passed `message` that needs to be rendered as HTML, set to true.
 * `actionLink` is not available if this is `true`.
 * @param { string } actionLink - passed in anchor tag
 * @param { string } modifierClass - additional class for component
 */
function Alert(_a) {
    var alertType = _a.alertType, message = _a.message, actionLink = _a.actionLink, modifierClass = _a.modifierClass, isInnerHtml = _a.isInnerHtml;
    var specialAlertClass, hasSpaceSeparator = actionLink ? ' ' : null;
    switch (alertType) {
        case 'critical':
            specialAlertClass = 'vx_alert-critical';
            break;
        case 'warning':
            specialAlertClass = 'vx_alert-warning';
            break;
        case 'help':
            specialAlertClass = 'vx_alert-help';
            break;
        case 'success':
            specialAlertClass = 'vx_alert-success';
            break;
        default:
            specialAlertClass = '';
    }
    return (React.createElement("div", { className: "vx_alert " + specialAlertClass + " " + (modifierClass || '') + " alertComponent" }, isInnerHtml ?
        React.createElement("p", { className: 'vx_alert-text', dangerouslySetInnerHTML: message }) :
        React.createElement("p", { className: 'vx_alert-text' },
            message,
            hasSpaceSeparator,
            actionLink)));
}
exports.default = Alert;
